import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";

import { Dialog, Typography } from "@mui/material";
import { yellow } from "@mui/material/colors";

// 店舗削除ダイアログ
// props...
//   open = ダイアログが開いていればtrue
//   shopData = 店舗データ
export default function DeleteShopDialog({
  open,
  onCloseDialog,
  shop,
  deleteAction,
}) {
  const { shopName } = shop;

  const onClickDelete = (event) => {
    deleteAction();
    alert(`店舗を削除しました。\n店舗名: ${shopName}`);
    onCloseDialog(event);
  };

  const onCloseCancel = (event) => {
    onCloseDialog(event);
  };

  return (
    <Dialog open={open} onClose={onCloseCancel}>
      <Box padding={2} minWidth={400}>
        <Typography fontSize={20} fontWeight={700}>
          店舗先削除
        </Typography>
        <Box marginTop={2} marginBottom={1}>
          <Typography>以下の店舗先を削除します。</Typography>
          <Box backgroundColor={yellow[100]} marginY={1} padding={1}>
            <Typography fontSize={20}>店舗名:&nbsp;{shopName}</Typography>
          </Box>
        </Box>

        <Grid container>
          <Grid item xs textAlign="center">
            <Button variant="contained" color="error" onClick={onClickDelete}>
              削除
            </Button>
          </Grid>
          <Grid item xs textAlign="center">
            <Button variant="outlined" onClick={onCloseCancel}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
}
